module.exports = __webpack_public_path__ + "media/images/icon__twitter-c4e0761610abd1d2aee412125dfebfa6.png";